"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _core = require("@chakra-ui/core");

var _default = _core.theme;
exports["default"] = _default;